import { createI18n } from 'vue-i18n';
import {
  DEFAULT_LOCALE,
  buildLocaleMessages,
  detectBrowserLocale,
  isSupportedUiLocale,
  toUiLocale,
} from '../models/localizacao';

function getJwtLocalizacao() {
  try {
    const raw = window.localStorage.getItem('user');
    if (!raw || raw === 'undefined')
      return null;
    const session = JSON.parse(raw);
    return session?.Usuario?.Usuario?.Localizacao ?? null;
  } catch (e) {
    return null;
  }
}

// JWT se autenticado, senão localStorage / navegador
function getDefaultLocale() {
  const jwtLocalizacao = getJwtLocalizacao();
  if (jwtLocalizacao)
    return toUiLocale(jwtLocalizacao);

  const savedLocale = localStorage.getItem('app-locale');
  if (savedLocale && isSupportedUiLocale(savedLocale))
    return savedLocale;

  return detectBrowserLocale();
}

const i18n = createI18n({
  legacy: false,
  locale: getDefaultLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: buildLocaleMessages(),
});

export default i18n;
